import { CONSTANTS } from '../config/constants';
import MapObject from '../models/map_object';

if (document.getElementById('gender-neutral-restrooms-map')) {
	let map = new mapboxgl.Map({
		container: 'gender-neutral-restrooms-map',
		style: CONSTANTS.map_style,
		center: CONSTANTS.map_center,
		zoom: 16,
		minZoom: 13,
		maxZoom: 20,
		maxBounds: [
			[-89.6, 42.96],
			[-89.3, 43.2],
		],
		scrollZoom: true,
		pitchWithRotate: false,
		dragRotate: false,
		hash: false,
		trackResize: true,
	});
	W.map = map;

	map.on('load', () => {
		let gender_neutral_restroom_marker;
		const lnglatInput = document.getElementById('gender_neutral_restroom_lnglat_string');

		// marker highlighting item's lnglat
		const createGenderNeutralRestroomMarker = (lnglat) => {
			const marker = new mapboxgl.Marker({ color: '#20bb43', scale: 1.5, draggable: true }).setLngLat(lnglat);
			marker.on('dragend', (e) => {
				const lnglat = e.target._lngLat;
				const lnglatText = lnglat.lng + ',' + lnglat.lat;
				lnglatInput.value = lnglatText;
			});
			return marker;
		};

		// add a geojson feature and fill it with #c5050c
		// then pan the map to the lnglat
		const highlightMapObject = (geojson, lnglat) => {
			map.addSource('map-object-source', {
				type: 'geojson',
				data: geojson,
			});
			map.addLayer(
				{
					id: 'map-object-layer',
					type: 'fill',
					source: 'map-object-source',
					paint: {
						'fill-color': '#c5050c',
					},
				},
				'road-label',
			);
			map.panTo(lnglat);
		};

		// if the location has a map_object association
		// highlight it. I.e. when editing an existing record.
		if (W.map_object && W.map_object.geojson) {
			highlightMapObject(W.map_object.geojson, W.map_object.lnglat);
		}

		// Display the other locations for reference
		W.layers['gender_neutral_restrooms'].add();

		// filter out the current location from the layer
		if (W.gender_neutral_restroom) {
			setTimeout(() => {
				W.map.setFilter('gender_neutral_restrooms-layer', [
					'!=',
					['get', 'id'],
					W.gender_neutral_restroom.id,
				]);
			}, 500);
		}

		// if we're editing a location, create a marker for it
		// and add it to the map
		if (W.gender_neutral_restroom && W.gender_neutral_restroom.lnglat) {
			gender_neutral_restroom_marker = createGenderNeutralRestroomMarker(W.gender_neutral_restroom.lnglat);
			gender_neutral_restroom_marker.addTo(map);
		}

		// update the location's marker and the lnglat
		// input field in the form
		const updateLocation = (e) => {
			const lnglatText = e.lngLat.lng + ',' + e.lngLat.lat;
			if (gender_neutral_restroom_marker) {
				gender_neutral_restroom_marker.setLngLat(e.lngLat);
			} else {
				gender_neutral_restroom_marker = createGenderNeutralRestroomMarker(e.lngLat);
				gender_neutral_restroom_marker.addTo(map);
			}
			lnglatInput.value = lnglatText;
		};
		map.on('click', updateLocation);

		const mapObjectsSelect = document.getElementById('gender_neutral_restroom_map_object_id');
		mapObjectsSelect.addEventListener('change', (e) => {
			const value = e.target.value;
			if (value) {
				// init our object and fetch its data from the API
				const map_object = new MapObject(value);
				map_object.fetch().then((mo) => {
					if (map.getLayer('map-object-layer')) {
						map.removeLayer('map-object-layer');
						map.removeSource('map-object-source');
					}
					highlightMapObject(mo.data.geojson, mo.data.lnglat);
				});
			}
		});
	});

	const mapObjectsSelect = document.getElementById('gender_neutral_restroom_map_object_id');
	if (mapObjectsSelect) {
		new TomSelect(mapObjectsSelect);
	}
}
